import { provideZoneChangeDetection } from "@angular/core";
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

function normalizeLegacyHashbangUrl(): void {
  if (!window.location.hash.startsWith('#!/')) return;

  const legacyUrl = window.location.hash.slice(3);
  const [legacyPath, legacyQuery] = legacyUrl.split('?');
  const baseHref = document.querySelector('base')?.getAttribute('href') || '/';
  const basePath = new URL(baseHref, window.location.origin).pathname.replace(/\/$/, '');
  const path = `${basePath}/${legacyPath}`.replace(/\/{2,}/g, '/');
  const query = legacyQuery !== undefined ? `?${legacyQuery}` : window.location.search;

  window.history.replaceState(null, '', `${path}${query}`);
}

normalizeLegacyHashbangUrl();

const gmoScript = document.createElement('script');
gmoScript.src = environment.mulPayTokenUrl;
gmoScript.type = 'text/javascript';
document.head.appendChild(gmoScript);

bootstrapApplication(AppComponent, {...appConfig, providers: [provideZoneChangeDetection(), ...appConfig.providers]})
  .catch((err) => console.error(err));
